import React from "react";

// given a value, the returned "debounceValue" will only update when "value"
// hasn't changed in the last "delay" milliseconds
export const useDebounceValue = <T,>(value: T, delay: number) => {
    const [debouncedValue, setDebouncedValue] = React.useState<T>(value);

    React.useEffect(() => {
        // update debounced value after delay
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        // cancel the timeout if value changes (also on delay change or
        // unmount)
        return () => {
            clearTimeout(handler);
        };

        // only re-call effect if value or delay changes
    }, [value, delay]);

    return debouncedValue;
};
